import { Search } from "lucide-react";
import React, { Dispatch, SetStateAction, useCallback } from "react";
import TextInput from "./TextInput";
import { useTranslation } from "react-i18next";
import useDebounce from "../../hooks/useDebounce";
import { cn } from "../../utils/cn";

interface SearchInputProps {
  search?: string;
  setSearch?: Dispatch<SetStateAction<string>>;
  styles?: string;

  localSearch?: string;
  setLocalSearch?: Dispatch<SetStateAction<string>>;
  disableDarkModeStyles?: boolean;
}

const SearchInput = ({
  search,
  setSearch,
  styles,
  localSearch,
  setLocalSearch,
  disableDarkModeStyles = false,
}: SearchInputProps) => {
  const { t, i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

  const debouncedSetSearch = useDebounce((value: string) => {
    setSearch?.(value);
  }, 500);

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setLocalSearch?.(event.target.value);
      debouncedSetSearch(event.target.value);
    },
    [debouncedSetSearch, setLocalSearch]
  );

  return (
    <div className={cn("relative md:w-[80%] lg:w-[50%] w-full", styles)}>
      <TextInput
        placeholder={t("search")}
        defaultValue={search}
        value={localSearch}
        onChange={handleInputChange}
        className={cn(
          "ps-10 text-black border-purple-primary/50",
          !disableDarkModeStyles && " dark:border-white/70 dark:text-white"
        )}
      />
      <Search
        className={cn(
          "absolute top-[55%] -translate-y-1/2 ",
          isArabic ? "right-3" : "left-3",
          !disableDarkModeStyles && "text-[#403f6880] dark:text-white/50"
        )}
        size={20}
      />
    </div>
  );
};

export default React.memo(SearchInput);
